/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "semalam",
        "-2": "kelmarin",
        "0": "hari ini",
        "1": "esok",
        "2": "lusa",
        "future": {
          "other": "dalam {0} hari"
        },
        "past": {
          "other": "{0} hari lalu"
        }
      },
      "day-narrow": {
        "-1": "semlm",
        "-2": "kelmarin",
        "0": "hari ini",
        "1": "esok",
        "2": "lusa",
        "future": {
          "other": "dlm {0} hari"
        },
        "past": {
          "other": "{0} hari lalu"
        }
      },
      "day-short": {
        "-1": "semalam",
        "-2": "kelmarin",
        "0": "hari ini",
        "1": "esok",
        "2": "lusa",
        "future": {
          "other": "dlm {0} hari"
        },
        "past": {
          "other": "{0} hari lalu"
        }
      },
      "hour": {
        "0": "jam ini",
        "future": {
          "other": "dalam {0} jam"
        },
        "past": {
          "other": "{0} jam lalu"
        }
      },
      "hour-narrow": {
        "0": "jam ini",
        "future": {
          "other": "dlm {0} jam"
        },
        "past": {
          "other": "{0} jam lalu"
        }
      },
      "hour-short": {
        "0": "jam ini",
        "future": {
          "other": "dlm {0} jam"
        },
        "past": {
          "other": "{0} jam lalu"
        }
      },
      "minute": {
        "0": "pada minit ini",
        "future": {
          "other": "dalam {0} minit"
        },
        "past": {
          "other": "{0} minit lalu"
        }
      },
      "minute-narrow": {
        "0": "pada minit ini",
        "future": {
          "other": "dlm {0} min"
        },
        "past": {
          "other": "{0} min lalu"
        }
      },
      "minute-short": {
        "0": "pada minit ini",
        "future": {
          "other": "dlm {0} min"
        },
        "past": {
          "other": "{0} min lalu"
        }
      },
      "month": {
        "-1": "bulan lalu",
        "0": "bulan ini",
        "1": "bulan depan",
        "future": {
          "other": "dalam {0} bulan"
        },
        "past": {
          "other": "{0} bulan lalu"
        }
      },
      "month-narrow": {
        "-1": "bln lalu",
        "0": "bln ini",
        "1": "bln depan",
        "future": {
          "other": "dlm {0} bln"
        },
        "past": {
          "other": "{0} bulan lalu"
        }
      },
      "month-short": {
        "-1": "bln lalu",
        "0": "bln ini",
        "1": "bln depan",
        "future": {
          "other": "dlm {0} bln"
        },
        "past": {
          "other": "{0} bln lalu"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "suku tahun lalu",
        "0": "suku tahun ini",
        "1": "suku tahun seterusnya",
        "future": {
          "other": "dalam {0} suku tahun"
        },
        "past": {
          "other": "{0} suku tahun lalu"
        }
      },
      "quarter-narrow": {
        "-1": "suku lepas",
        "0": "suku ini",
        "1": "suku seterusnya",
        "future": {
          "other": "dlm {0} suku thn"
        },
        "past": {
          "other": "{0} suku thn lalu"
        }
      },
      "quarter-short": {
        "-1": "suku lepas",
        "0": "suku ini",
        "1": "suku seterusnya",
        "future": {
          "other": "dlm {0} suku thn"
        },
        "past": {
          "other": "{0} suku thn lalu"
        }
      },
      "second": {
        "0": "sekarang",
        "future": {
          "other": "dalam {0} saat"
        },
        "past": {
          "other": "{0} saat lalu"
        }
      },
      "second-narrow": {
        "0": "sekarang",
        "future": {
          "other": "dlm {0} saat"
        },
        "past": {
          "other": "{0} saat lalu"
        }
      },
      "second-short": {
        "0": "sekarang",
        "future": {
          "other": "dlm {0} saat"
        },
        "past": {
          "other": "{0} saat lalu"
        }
      },
      "week": {
        "-1": "minggu lalu",
        "0": "minggu ini",
        "1": "minggu depan",
        "future": {
          "other": "dalam {0} minggu"
        },
        "past": {
          "other": "{0} minggu lalu"
        }
      },
      "week-narrow": {
        "-1": "mgu lepas",
        "0": "mgu ini",
        "1": "mgu depan",
        "future": {
          "other": "dlm {0} mgu"
        },
        "past": {
          "other": "{0} mgu lalu"
        }
      },
      "week-short": {
        "-1": "mgu lepas",
        "0": "mgu ini",
        "1": "mgu depan",
        "future": {
          "other": "dlm {0} mgu"
        },
        "past": {
          "other": "{0} mgu lalu"
        }
      },
      "year": {
        "-1": "tahun lalu",
        "0": "tahun ini",
        "1": "tahun depan",
        "future": {
          "other": "dalam {0} tahun"
        },
        "past": {
          "other": "{0} tahun lalu"
        }
      },
      "year-narrow": {
        "-1": "thn lepas",
        "0": "thn ini",
        "1": "thn depan",
        "future": {
          "other": "dalam {0} thn"
        },
        "past": {
          "other": "{0} thn lalu"
        }
      },
      "year-short": {
        "-1": "thn lepas",
        "0": "thn ini",
        "1": "thn depan",
        "future": {
          "other": "dalam {0} thn"
        },
        "past": {
          "other": "{0} thn lalu"
        }
      }
    },
    "locale": "ms-SG"
  });
}